<!-- Purchase Manager Landing Page -->
<div class="pm-landing-container"
  [class.has-cart-bar]="hasCartItems && !isDemoSearchMode"
  [class.pm-public-demo]="isPublicDemo">
  <!-- Header -->
  <div class="pm-header"
    *ngIf="!isPublicDemo">
    <div class="pm-header-left">
      <div class="pm-header-icon">
        <i class="material-icons" style="color: #e6b401; font-size: 28px;">shopping_cart</i>
      </div>
      <div class="pm-header-text">
        <h1 class="pm-title">Purchase Manager</h1>
        <p class="pm-subtitle">Search multiple items, SKUs, or commodities instantly.</p>
      </div>
    </div>
    <div class="pm-header-right" style="display: flex; gap: 12px;"
      *ngIf="!isPublicDemo">
      <button class="pm-inventory-pr-btn"
        (click)="toggleInventoryPrModal()">
        <i class="material-icons" style="color: #4CAF50;">inventory</i>
        Inventory PR
      </button>
      <button class="pm-hp-purchases-btn"
        *ngIf="!isDemoSearchMode"
        (click)="toggleHpRecentPurchasesModal()">
        <i class="material-icons">local_shipping</i>
        Recent Purchases
      </button>
    </div>
  </div>

  <!-- Search Section -->
  <div class="pm-search-section">
    <div class="pm-search-box" [class.focused]="showSearchDropdown">
      <div class="pm-search-input-row">
        <i class="material-icons search-icon">search</i>
        <input type="text" #searchInput class="pm-search-input" [(ngModel)]="searchQuery" (input)="onSearchInput()"
          (focus)="showSearchDropdown = searchResults.length > 0" (blur)="onSearchBlur()"
          (keydown.enter)="onSearchSubmit()" placeholder="Search eg: 'Red Onion 50T', 'Potatoes Grade A'..." />
        <span class="pm-search-shortcut">Ctrl + K</span>
        <app-hyperpure-sheet-upload
          class="pm-excel-upload"
          *ngIf="showExcelUpload"
          variant="bar"
          [entityId]="selectedEntityId"
          (rowsReady)="openSheetSearch($event)">
        </app-hyperpure-sheet-upload>
        <button class="pm-search-btn" (click)="onSearchNavigate()"
          [disabled]="searchTags.length === 0 && (!searchQuery || searchQuery.length < 2)">
          Search
          <span class="pm-search-count" *ngIf="searchTags.length > 0">({{ searchTags.length }})</span>
        </button>
      </div>

      <!-- Search Tags -->
      <div class="pm-search-tags" *ngIf="searchTags.length > 0">
        <span class="pm-tag" *ngFor="let tag of visibleTags">
          {{ tag.name }}
          <i class="material-icons pm-tag-close" (click)="removeSearchTag(tag)">close</i>
        </span>
        <span class="pm-tag-more" *ngIf="hiddenTagCount > 0 && !showAllTags" (click)="showAllTags = true"
          style="cursor:pointer">
          +{{ hiddenTagCount }} More
        </span>
        <span class="pm-tag-more" *ngIf="showAllTags && searchTags.length > 8" (click)="showAllTags = false"
          style="cursor:pointer">
          Show less
        </span>
      </div>
    </div>

    <!-- Search Dropdown -->
    <div class="pm-search-dropdown" *ngIf="showSearchDropdown">
      <div class="pm-search-loading" *ngIf="isSearching">
        <i class="material-icons spin">refresh</i>
        <span>Searching...</span>
      </div>

      <div class="pm-search-empty" *ngIf="!isSearching && searchResults.length === 0 && searchQuery.length >= 2">
        No results found for "{{ searchQuery }}"
      </div>

      <div class="pm-search-result" *ngFor="let result of searchResults" (mousedown)="addSearchTag(result)">
        <div class="result-name">{{ result.itemName || result.item_name || result.name }}</div>
        <div class="result-details" *ngIf="result.supplierName || result.supplier_name">
          <span class="result-supplier">{{ result.supplierName || result.supplier_name }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Auto-Fill Smart Cart Section -->
  <app-auto-fill-smart-cart [entityId]="selectedEntityId" (configChanged)="onSmartCartConfigChanged($event)">
  </app-auto-fill-smart-cart>

  <!-- Quick Add Section -->
  <div class="pm-quick-add"
    *ngIf="!isDemoSearchMode && !isPublicDemo">
    <h3 class="pm-section-label">Quick Add <i class="material-icons"
        style="font-size: 16px; vertical-align: middle; color: #000000;">flash_on</i></h3>
    <div class="pm-quick-add-pills">
      <button class="pm-pill" *ngFor="let category of quickAddCategories" [class.active]="category.active"
        (click)="onQuickAddClick(category)">
        <i class="material-icons">{{ category.icon }}</i>
        <span>{{ category.label }}</span>
        <span class="pill-count" *ngIf="category.count">({{ category.count }})</span>
        <i class="material-icons pill-close" *ngIf="category.active"
          (click)="dismissQuickAdd(category); $event.stopPropagation()">close</i>
      </button>
    </div>
  </div>

  <!-- Hyperpure Promotional Banner -->
  <div class="pm-hyperpure-banner"
    *ngIf="!isPublicDemo">
    <img src="assets/images/hyperpure-promo-banner.jpg" alt="Hyperpure - Everything your kitchen needs" />
  </div>

  <!-- Loading Overlay -->
  <div class="pm-loading" *ngIf="isLoading">
    <div class="pm-spinner"></div>
    <span>Loading items...</span>
  </div>

  <!-- Recent Searched Section -->
  <div class="pm-card-section"
    *ngIf="!isDemoSearchMode && recentPurchases.length > 0 && !isLoading">
    <h3 class="pm-section-title">Recent Searched</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card" *ngFor="let item of recentPurchases">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'" [alt]="item.name" loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row" *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn" (click)="removeFromSearch(item)" title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn" *ngIf="!isItemAdded(item)" (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Most Searched Section -->
  <div class="pm-card-section"
    *ngIf="!isDemoSearchMode && mostSearchedItems.length > 0 && !isLoading">
    <h3 class="pm-section-title">Most Searched</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card" *ngFor="let item of mostSearchedItems">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'" [alt]="item.name" loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row" *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn" (click)="removeFromSearch(item)" title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn" *ngIf="!isItemAdded(item)" (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Trending Near You Section -->
  <div class="pm-card-section"
    *ngIf="!isDemoSearchMode && trendingItems.length > 0 && !isLoading">
    <h3 class="pm-section-title">Trending near you</h3>
    <div class="pm-card-scroll">
      <div class="pm-product-card" *ngFor="let item of trendingItems">
        <div class="pm-card-image">
          <img [src]="item.imageUrl || 'assets/images/placeholder-product.svg'" [alt]="item.name" loading="lazy"
            onerror="this.src='assets/images/placeholder-product.svg'" />
        </div>
        <div class="pm-card-body">
          <h4 class="pm-card-name">{{ item.name }}</h4>
          <p class="pm-card-package">{{ item.packageInfo }}</p>
          <div class="pm-card-btn-row" *ngIf="isItemAdded(item)">
            <span class="pm-added-label"><i class="material-icons"
                style="font-size: 14px; vertical-align: middle;">check</i> Added</span>
            <button class="pm-remove-btn" (click)="removeFromSearch(item)" title="Remove from search">
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
          <button class="pm-add-search-btn" *ngIf="!isItemAdded(item)" (click)="addToSearch(item)">
            Add to Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="pm-empty-state"
    *ngIf="!isDemoSearchMode && !isLoading && recentPurchases.length === 0 && mostSearchedItems.length === 0 && trendingItems.length === 0">
    <i class="material-icons">shopping_basket</i>
    <h3>No items found</h3>
    <p>Start by searching for items or use Quick Add to get started.</p>
  </div>

  <!-- Bottom Cart Bar -->
  <div class="bottom-cart-bar"
    [class.demo-cart-bar]="isPublicDemo"
    *ngIf="hasCartItems && !isDemoSearchMode">
    <div class="cart-total-section">
      <button class="cart-icon-btn" (click)="goToPriceDiscovery()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M7.4 17C6.84 17 6.4 17.44 6.4 18C6.4 18.56 6.84 19 7.4 19C7.96 19 8.4 18.56 8.4 18C8.4 17.44 7.96 17 7.4 17ZM17.4 17C16.84 17 16.4 17.44 16.4 18C16.4 18.56 16.84 19 17.4 19C17.96 19 18.4 18.56 18.4 18C18.4 17.44 17.96 17 17.4 17ZM15.9 14.5C16.65 14.5 17.29 14.07 17.6 13.43L20.8 7.64C20.89 7.47 20.9 7.28 20.9 7.1C20.9 6.55 20.45 6.1 19.9 6.1H6.62L5.68 4.1H2.4V6.1H4.4L8.01 13.68L6.72 16.03C6.49 16.44 6.4 16.92 6.4 17.43C6.4 18.3 7.12 19.03 8 19.03H19.4V17.03H8.42C8.28 17.03 8.16 16.91 8.16 16.77L8.2 16.62L9.31 14.6L15.9 14.5V14.5Z"
            fill="#333" />
        </svg>
      </button>
      <div class="cart-total-info">
        <span class="cart-label">CART VALUE</span>
        <span class="cart-value">₹{{ totalCartValue.toFixed(2) }}</span>
      </div>
      <button class="scroll-btn left" (click)="scrollCarts('left')">
        <i class="material-icons">chevron_left</i>
      </button>
    </div>

    <div class="supplier-carts-wrapper">
      <div class="supplier-carts-container" #cartsContainer>
        <div class="supplier-cart-card" *ngFor="let cart of supplierCartData">
          <div class="cart-provider-logo">
            <ng-container [ngSwitch]="cart.platform">
              <span class="provider-icon ud-icon" *ngSwitchCase="'udaan'">
                <img src="assets/images/udaan_cart.png" alt="Udaan" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon hp-icon" *ngSwitchCase="'hyperpure'">
                <img src="assets/images/hyperpure_cart.png" alt="Hyperpure" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon dm-icon" *ngSwitchCase="'dmart'">
                <img src="assets/images/dmart_cart.png" alt="DMart" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon dl-icon" *ngSwitchCase="'deliverit'">
                <img src="assets/images/deliverIt.png" alt="DeliverIt" onerror="this.style.display='none'">
              </span>
              <span class="provider-icon sa-icon" *ngSwitchCase="'swiggy'">
                <img src="assets/images/swiggy-assure.png" alt="Assure" onerror="this.style.display='none'">
              </span>
            </ng-container>
          </div>
          <div class="cart-provider-info">
            <span class="provider-name">{{ cart.supplierName | uppercase }}</span>
            <div class="provider-cart-meta">
              <span class="provider-cart-value">₹{{ cart.totalValue.toFixed(2) }}</span>
              <span class="provider-cart-items">{{ cart.totalCount }} {{ cart.totalCount === 1 ? 'item' : 'items'
                }}</span>
            </div>
          </div>
          <button class="checkout-btn"
            *ngIf="canCheckout"
            (click)="proceedToBuy(cart.platform)">
            <span class="checkout-label-full">PROCEED TO BUY</span>
            <span class="checkout-label-short">BUY</span>
          </button>
        </div>
      </div>
      <button class="scroll-btn right" (click)="scrollCarts('right')">
        <i class="material-icons">chevron_right</i>
      </button>
    </div>
  </div>

  <div class="swiggy-iframe-backdrop"
    *ngIf="showSwiggyIframe"
    (click)="closeSwiggyIframe()"></div>
  <div class="swiggy-iframe-overlay"
    *ngIf="showSwiggyIframe">
    <div class="swiggy-iframe-header">
      <div class="swiggy-iframe-title">
        <img src="assets/images/swiggy-assure.png" alt="Assure" onerror="this.style.display='none'">
        <span>Assure Cart</span>
      </div>
      <div class="swiggy-iframe-actions">
        <button class="iframe-control-btn" type="button" (click)="reloadSwiggyIframe()" title="Refresh">
          <i class="material-icons">refresh</i>
        </button>
        <button class="iframe-control-btn close-btn" type="button" (click)="closeSwiggyIframe()" title="Close">
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>
    <div class="swiggy-iframe-body">
      <iframe #swiggyCheckoutFrame
        *ngIf="swiggyIframeUrlSafe"
        [src]="swiggyIframeUrlSafe"
        class="swiggy-iframe"
        frameborder="0"
        allow="payment; geolocation"
        (load)="onSwiggyIframeLoaded($event)"></iframe>
    </div>
  </div>

  <!-- Hyperpure Supplier Child Component (handles iframe overlay) -->
  <app-hyperpure-supplier #hyperpureSupplier
    [entityId]="selectedEntityId"
    [storeUuid]="hyperpureStoreUuid"
    (iframeClosed)="onIframeClosed()"
    (cartUpdated)="onHyperpureCartUpdated($event)">
  </app-hyperpure-supplier>

  <!-- DeliverIt Supplier Child Component (handles iframe overlay) -->
  <app-deliverit-supplier #deliveritSupplier
    [entityId]="selectedEntityId"
    [storeData]="deliveritStoreData"
    (iframeClosed)="onIframeClosed()"
    (cartUpdated)="onDeliveritCartUpdated($event)">
  </app-deliverit-supplier>

<app-profile-setup-modal *ngIf="!isPublicDemo"></app-profile-setup-modal>

  <!-- HP Recent Purchases Modal -->
  <div class="hp-recent-modal-overlay" *ngIf="showHpRecentPurchasesModal" (click)="toggleHpRecentPurchasesModal()">
    <div class="hp-recent-modal" (click)="$event.stopPropagation()">
      <!-- Modal Header -->
      <div class="hp-recent-modal-header">
        <div class="hp-recent-modal-title">
          <i class="material-icons" style="color: #e6b401;">local_shipping</i>
          <h3>Recent Purchases</h3>
          <span class="hp-recent-count-badge" *ngIf="hpRecentPurchaseTotalCount > 0">
            {{ hpRecentPurchaseTotalCount }} items
          </span>
        </div>
        <button class="hp-recent-close-btn" (click)="toggleHpRecentPurchasesModal()">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Search Bar -->
      <div class="hp-recent-search">
        <i class="material-icons">search</i>
        <input type="text" [(ngModel)]="searchHpRecentPurchaseTerm" placeholder="Search items..." />
      </div>

      <!-- Loading State -->
      <div class="hp-recent-loading" *ngIf="isHpRecentPurchasesLoading">
        <div class="pm-spinner"></div>
        <span>Loading Recent Purchases...</span>
      </div>

      <!-- Content -->
      <div class="hp-recent-content" *ngIf="!isHpRecentPurchasesLoading">

        <!-- Live Items Section -->
        <div class="hp-recent-section" *ngIf="filteredHpLiveItems.length > 0">
          <div class="hp-section-header">
            <h4>
              <i class="material-icons"
                style="color: #4CAF50; font-size: 18px; vertical-align: middle;">check_circle</i>
              Available Items
            </h4>
            <span class="hp-section-count">{{ hpRecentPurchaseLiveCount }} items</span>
          </div>
          <div class="hp-items-grid">
            <div class="hp-item-card" *ngFor="let item of filteredHpLiveItems">
              <div class="hp-item-image">
                <img [src]="item.productImages || 'assets/images/placeholder-product.svg'" [alt]="item.itemName"
                  loading="lazy" onerror="this.src='assets/images/placeholder-product.svg'" />
                <span class="hp-stock-badge in-stock" *ngIf="item.isInStock">In Stock</span>
                <span class="hp-stock-badge out-of-stock" *ngIf="!item.isInStock">Out of Stock</span>
              </div>
              <div class="hp-item-body">
                <h5 class="hp-item-name" [title]="item.itemName">{{ item.itemName }}</h5>
                <p class="hp-item-unit">{{ item.unit }}</p>
                <div class="hp-item-price-row">
                  <span class="hp-item-price">₹{{ item.rate?.toFixed(2) || '0.00' }}</span>
                  <span class="hp-item-orders" *ngIf="item.orderCount">
                    {{ item.orderCount }} orders
                  </span>
                </div>
                <div class="hp-item-actions">
                  <button class="hp-search-btn" (click)="searchHpRecentPurchaseItem(item)" title="Search this item">
                    <i class="material-icons" style="font-size: 14px;">search</i>
                    Compare
                  </button>
                  <div class="hp-qty-controls" *ngIf="item.selectedQuantity > 0">
                    <button class="hp-qty-btn minus" (click)="updateHpQuantity(item, -1)"
                      [disabled]="item.isAddingToCart">
                      <i class="material-icons">remove</i>
                    </button>
                    <span class="hp-qty-val">
                      <i class="material-icons hp-spinner" *ngIf="item.isAddingToCart">refresh</i>
                      <ng-container *ngIf="!item.isAddingToCart">{{ item.selectedQuantity }}</ng-container>
                    </span>
                    <button class="hp-qty-btn plus" (click)="updateHpQuantity(item, 1)"
                      [disabled]="item.isAddingToCart">
                      <i class="material-icons">add</i>
                    </button>
                  </div>
                  <button class="hp-add-tag-btn" *ngIf="!item.selectedQuantity" (click)="addHpToCart(item)"
                    [disabled]="item.isAddingToCart || !item.isInStock" title="Add to cart">
                    <i class="material-icons hp-spinner" *ngIf="item.isAddingToCart">refresh</i>
                    <i class="material-icons" style="font-size: 18px;" *ngIf="!item.isAddingToCart">add</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Missing Items Section -->
        <div class="hp-recent-section hp-missing-section" *ngIf="filteredHpMissingItems.length > 0">
          <div class="hp-section-header">
            <h4>
              <i class="material-icons" style="color: #f59e0b; font-size: 18px; vertical-align: middle;">warning</i>
              Missing Items
            </h4>
            <span class="hp-section-count missing">{{ hpRecentPurchaseMissingCount }} items</span>
          </div>
          <div class="hp-missing-banner">
            <i class="material-icons">info_outline</i>
            <span>We are not able to find the latest price for the following items.</span>
          </div>
          <div class="hp-items-grid">
            <div class="hp-item-card hp-item-missing" *ngFor="let item of filteredHpMissingItems">
              <div class="hp-item-image">
                <img [src]="item.productImages || 'assets/images/placeholder-product.svg'" [alt]="item.itemName"
                  loading="lazy" onerror="this.src='assets/images/placeholder-product.svg'" />
                <span class="hp-stock-badge out-of-stock">Unavailable</span>
              </div>
              <div class="hp-item-body">
                <h5 class="hp-item-name" [title]="item.itemName">{{ item.itemName }}</h5>
                <p class="hp-item-unit">{{ item.unit }}</p>
                <div class="hp-item-price-row">
                  <span class="hp-item-price muted">₹{{ item.rate?.toFixed(2) || '0.00' }}</span>
                  <span class="hp-item-last-price-label">Last known price</span>
                </div>
                <div class="hp-missing-warning">
                  <i class="material-icons">error_outline</i>
                  <span>Latest price not available</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div class="hp-recent-empty" *ngIf="filteredHpLiveItems.length === 0 && filteredHpMissingItems.length === 0">
          <i class="material-icons">inventory_2</i>
          <h4>No Recent Purchases found</h4>
          <p>No recent purchase history from Hyperpure in the last 60 days.</p>
        </div>
      </div>
    </div>
  </div>

<!-- Inventory PR Modal -->
<app-inventory-pr-modal
  [isVisible]="showInventoryPrModal"
  [entityId]="selectedEntityId"
  [searchTags]="searchTags"
  (closeModal)="showInventoryPrModal = false"
  (searchItems)="handleInventoryPrSearch($event)">
</app-inventory-pr-modal>

<app-connect-lead-modal></app-connect-lead-modal>
